import React from 'react';
import Profile from '../components/user/profile';
import {Header} from '../components/global/header';
import {Footer} from '../components/global/footer';

const ProfilePage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <Profile />
      <Footer />
    </div>
  );
};

export default ProfilePage;
